import { useQuery } from '@tanstack/react-query';

import { getSuggestionsWithAI } from 'features/order/substitution-flow/infra';

import { ITEMS_REPLACEMENT_MODEL_INIT } from 'features/order/substitution-flow/domain';

import type { GetSuggestionsWithAIParams } from 'features/order/substitution-flow/domain';

export function useGetSuggestionsWithAI(props: GetSuggestionsWithAIParams) {
  const { orderId, isProduct, productId, toppingId } = props;
  const isEnabled = !!productId || !!toppingId;
  const _useQuery = useQuery({
    enabled: isEnabled,
    queryKey: [
      'orders',
      'replacement',
      { orderId, withAI: true, isProduct, productId, toppingId },
    ],
    queryFn: () => getSuggestionsWithAI(props),
    staleTime: 2 * 60 * 1_000,
  });
  return {
    ..._useQuery,
    data:
      isEnabled && _useQuery.data
        ? _useQuery.data
        : ITEMS_REPLACEMENT_MODEL_INIT,
  };
}
